export default __webpack_public_path__ + "static/media/backward.c323d886.svg";